<template>
    <div id="trusts" class="home-trusts">
        <div class="trusts-container">
            <h2 class="home-trusts__title">300 000 Belges nous font déjà confiance, <br> rejoignez-les !</h2>
            <ul class="trust-list">
                <li class="trust">
                    <img src="/images/fr_multigift/trust1.svg">
                    <div>
                        <strong class="trust-title">60 ans</strong><br>
                        <span class="trust-subtitle">d'expertise</span>
                    </div>
                </li>
                <li class="trust">
                    <img src="/images/fr_multigift/trust2.svg">
                    <div>
                        <strong class="trust-title">1 <sup>re</sup></strong><br>
                        <span class="trust-subtitle">association de <br> consommateurs <br> en Belgique</span>
                    </div>
                </li>
                <li class="trust">
                    <img src="/images/fr_multigift/trust3.svg">
                    <div>
                        <strong class="trust-title">Indépendant</strong><br>
                        <span class="trust-subtitle">de tout lobby et <br> de toute enseigne</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    name: "HomeTrust",
}
</script>

<style scoped>

</style>
